<section>
    <!-- LARGE MODAL -->
    <div class="flex items-start justify-between p-4 border-b border-gray-200 rounded-t dark:border-gray-600">
        <h6 class="text-lg font-semibold text-gray-900 dark:text-white">
            {{view.isViewOnly ? 'Pax Details' : 'Reserve'}} {{view?.itineraryOption?.reference}}
            <small *ngIf="!view.isViewOnly" class="text-sm font-normal text-gray-500">The services on this itinerary will be send through for pre-book, but no confirmation yet</small>
        </h6>
        <button type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white" (click)="close()">
            <span class="sr-only">Close</span>
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
        </button>
    </div>
    <div class="p-6 space-y-6">
        <div class="p-0 bg-white" *ngIf="view.occupancy">
            
            <ng-container *ngFor="let room of [].constructor(toNumber(view.occupancy.length)); let roomIndex = index">
                <div class="grid grid-cols-12 gap-4 mb-4">
                    <div class="col-span-12">
                        <div class="mb-4">
                            <label class="block text-sm font-medium text-gray-700 font-bold">Room #{{roomIndex + 1}} 
                                <span class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded">{{view.occupancy[roomIndex].item?.service}} ({{view.occupancy[roomIndex].item?.id}})</span>
                                <span class="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded ml-1">{{view.occupancy[roomIndex].item?.supplier}}</span>
                                <span *ngIf="view.occupancy[roomIndex].item?.childAges" class="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded ml-1">Child Ages {{view.occupancy[roomIndex].item?.childAges}}</span>
                                <span class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded ml-1">{{view.occupancy[roomIndex].item?.isRefundable ? "Refundable" : "Non-refundable"}}</span>
                                <span *ngIf="view.occupancy[roomIndex].item?.cancellationCondition" class="bg-yellow-100 text-yellow-800 text-xs font-medium px-2.5 py-0.5 rounded ml-1">{{view.occupancy[roomIndex].item?.cancellationCondition}}</span>                                
                            </label>
                        </div>
                    </div>
                </div>
                
                <div class="grid grid-cols-12 gap-4 mb-4" *ngFor="let item of [].constructor(toNumber(view.occupancy[roomIndex].adultCount)); let adultCount = index">
                    <div class="col-span-1">
                        <div class="mb-4">
                            <label class="block text-sm font-medium text-gray-700 text-right">Adult #{{adultCount + 1}}</label>
                        </div>
                    </div>
                    <div class="col-span-1">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Title" [(ngModel)]="view.occupancy[roomIndex].adults[adultCount].title">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Firstname" [(ngModel)]="view.occupancy[roomIndex].adults[adultCount].firstName">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Surname" [(ngModel)]="view.occupancy[roomIndex].adults[adultCount].lastName">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input type="email" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Email Address" [(ngModel)]="view.occupancy[roomIndex].adults[adultCount].emailAddress">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4" *ngIf="adultCount == 0">
                            <div class="flex space-x-2">
                                <input *ngIf="adultCount == 0" ngbTooltip="Phone number country code" type="tel" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-1/4 p-2.5" placeholder="Country Code" [(ngModel)]="view.occupancy[roomIndex].adults[adultCount].countryAccessCode">
                                <input *ngIf="adultCount == 0" ngbTooltip="Phone number area code" type="tel" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-1/4 p-2.5" placeholder="Area Code" [(ngModel)]="view.occupancy[roomIndex].adults[adultCount].areaCityCode">
                                <input *ngIf="adultCount == 0" ngbTooltip="Phone number" type="tel" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-2/4 p-2.5" placeholder="Phone Number" [(ngModel)]="view.occupancy[roomIndex].adults[adultCount].phoneNumber">
                            </div>
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input ngbTooltip="Date of Birth" type="date" [max]="view.occupancy[roomIndex].adults[adultCount].minDate | date:'yyyy-MM-dd'" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Date of Birth" [(ngModel)]="view.occupancy[roomIndex].adults[adultCount].dateOfBirth">
                        </div>
                    </div>
                </div>
                
                <div class="grid grid-cols-12 gap-4 mb-4" *ngFor="let item of [].constructor(toNumber(view.occupancy[roomIndex].teenCount)); let teenCount = index">
                    <div class="col-span-1">
                        <div class="mb-4">
                            <label class="block text-sm font-medium text-gray-700 text-right">Teen #{{teenCount + 1}}</label>
                        </div>
                    </div>
                    <div class="col-span-1">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Title" [(ngModel)]="view.occupancy[roomIndex].teens[teenCount].title">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Firstname" [(ngModel)]="view.occupancy[roomIndex].teens[teenCount].firstName">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Surname" [(ngModel)]="view.occupancy[roomIndex].teens[teenCount].lastName">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <!-- Empty column -->
                    </div>
                    <div class="col-span-2">
                        <!-- Empty column -->
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input ngbTooltip="Date of Birth" type="date" [max]="view.occupancy[roomIndex].teens[teenCount].minDate | date:'yyyy-MM-dd'" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Date of Birth" [(ngModel)]="view.occupancy[roomIndex].teens[teenCount].dateOfBirth">
                        </div>
                    </div>
                </div>
                
                <div class="grid grid-cols-12 gap-4 mb-4" *ngFor="let item of [].constructor(toNumber(view.occupancy[roomIndex].childCount)); let childCount = index">
                    <div class="col-span-1">
                        <div class="mb-4">
                            <label class="block text-sm font-medium text-gray-700 text-right">Child #{{childCount + 1}}</label>
                        </div>
                    </div>
                    <div class="col-span-1">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Title" [(ngModel)]="view.occupancy[roomIndex].children[childCount].title">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Firstname" [(ngModel)]="view.occupancy[roomIndex].children[childCount].firstName">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Surname" [(ngModel)]="view.occupancy[roomIndex].children[childCount].lastName">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <!-- Empty column -->
                    </div>
                    <div class="col-span-2">
                        <!-- Empty column -->
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input ngbTooltip="Date of Birth" type="date" [max]="view.occupancy[roomIndex].children[childCount].minDate | date:'yyyy-MM-dd'" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Date of Birth" [(ngModel)]="view.occupancy[roomIndex].children[childCount].dateOfBirth">
                        </div>
                    </div>
                </div>
                
                <div class="grid grid-cols-12 gap-4 mb-4" *ngFor="let item of [].constructor(toNumber(view.occupancy[roomIndex].infantCount)); let infantCount = index">
                    <div class="col-span-1">
                        <div class="mb-4">
                            <label class="block text-sm font-medium text-gray-700 text-right">Infant #{{infantCount + 1}}</label>
                        </div>
                    </div>
                    <div class="col-span-1">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Title" [(ngModel)]="view.occupancy[roomIndex].infants[infantCount].title">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Firstname" [(ngModel)]="view.occupancy[roomIndex].infants[infantCount].firstName">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input type="text" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Surname" [(ngModel)]="view.occupancy[roomIndex].infants[infantCount].lastName">
                        </div>
                    </div>
                    <div class="col-span-2">
                        <!-- Empty column -->
                    </div>
                    <div class="col-span-2">
                        <!-- Empty column -->
                    </div>
                    <div class="col-span-2">
                        <div class="mb-4">
                            <input ngbTooltip="Date of Birth" type="date" [max]="view.occupancy[roomIndex].infants[infantCount].minDate | date:'yyyy-MM-dd'" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Date of Birth" [(ngModel)]="view.occupancy[roomIndex].infants[infantCount].dateOfBirth">
                        </div>
                    </div>
                </div>

                <!-- Room/Cabin Selection Section -->
                <ng-container *ngIf="view.occupancy[roomIndex].item?.availableRoom && view.occupancy[roomIndex].item.availableRoom.length > 0">
                    <div class="grid grid-cols-12 gap-4 mb-4">
                        <div class="col-span-12">
                            <div class="mb-4">
                                <label class="block text-sm font-medium text-gray-700 font-bold mb-3">Select Cabin to Reserve:</label>
                                <div class="flex flex-wrap gap-2">
                                    <div *ngFor="let room of view.occupancy[roomIndex].item.availableRoom; let i = index" class="flex items-center">
                                        <input 
                                            type="radio" 
                                            [id]="'room-' + roomIndex + '-' + i" 
                                            [name]="'selectedRoom-' + roomIndex" 
                                            [value]="room" 
                                            [(ngModel)]="view.occupancy[roomIndex].item.selectedRoom"
                                            (change)="updateRoomSelection(view.occupancy[roomIndex].item)"
                                            class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 focus:ring-2 mr-2">
                                        <label 
                                            [for]="'room-' + roomIndex + '-' + i" 
                                            class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded cursor-pointer hover:bg-blue-200 transition-colors">
                                            {{room || 'Room ' + (i + 1)}}
                                        </label>
                                    </div>
                                </div>
                                <!-- Show selected room info -->
                                <div *ngIf="view.occupancy[roomIndex].item.selectedRoom" class="mt-2">
                                    <span class="text-sm text-green-600 font-medium">
                                        Selected: {{view.occupancy[roomIndex].item.selectedRoom}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>

            </ng-container>
       
            <div class="hidden">
                <!-- Hidden dietary requirements section -->
            </div>

            <div *ngIf="!view.isViewOnly">
            <hr class="my-6 border-gray-200">

            <div class="" *ngFor="let item of view.itineraryOption?.items?.content">
                <div class="flex items-center justify-between">
                    <div class="cursor-pointer" (click)="item.factsOpen=!item.factsOpen">
                        <h6 class="mb-0 mt-1 text-gray-900 font-semibold">
                            {{item.supplier}}
                        </h6>
                        <small class="text-gray-500">Important information regarding checkin, checkout, fees and other policies</small>
                    </div>
                    <div class="ml-auto">
                        <button (click)="item.factsOpen = !item.factsOpen" class="text-gray-500 hover:text-gray-700" type="button">
                            <svg *ngIf="item.factsOpen" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clip-rule="evenodd"></path></svg>
                            <svg *ngIf="!item.factsOpen" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                        </button>
                    </div>
                </div>
                <div class="bg-gray-50 p-4 mt-2 rounded-lg" *ngIf="item.factsOpen">
                    <div class="grid grid-cols-12 gap-4" *ngFor="let factGroup of item.facts">
                        <div class="col-span-12 mt-5" *ngIf="factGroup.children.length > 0">
                            <h6 class="font-medium text-gray-900">{{factGroup.group}}</h6>
                            <div class="grid grid-cols-12 gap-4 mt-2" *ngFor="let item of factGroup.children">
                                <div class="col-span-3 text-sm font-medium text-gray-700">{{item.name}}</div>
                                <div class="col-span-9 text-sm text-gray-600" [innerHTML]="item.value"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="my-6 border-gray-200">

            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-12">
                    <h6 class="mb-0 mt-1 text-gray-900 font-semibold">
                        Booking Remarks
                    </h6>
                    <small class="text-gray-500">Capture any other requirements eg: Dietary requirements, travel insurance, birthday, anniversary, honeymoon etc....</small>
                    <div class="mt-2">
                        <textarea rows="3" class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Enter any remarks for this booking..." [(ngModel)]="view?.itinerary.remarks"></textarea>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-12 gap-4 mb-2">
                <div class="col-span-10 text-right">
                    <span class="text-sm font-medium text-gray-700">Taxes & Fees</span><br/>
                    <small class="text-xs text-gray-500">This charge includes estimated amounts the travel service provider (i.e. hotel, car rental company) pays for their taxes, and/or taxes that we pay, to taxing authorities on your booking (including but not limited to, sales, occupancy, and value added tax). This amount may also include any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the hotel supplier and/or the site you booked on, retain as part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how you booked. For more details, please see the Terms and Conditions.</small>
                </div>
                <div class="col-span-2 text-right">
                    <span class="text-sm">R {{view?.itineraryOption?.taxFeesAmount | number:'1.2-2'}}</span>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-4 mb-2">
                <div class="col-span-10 text-right">
                    <span class="text-sm font-medium text-gray-700">Sales Tax</span><br/>
                    <small class="text-xs text-gray-500">Taxes collected by local municipalities or states</small>
                </div>
                <div class="col-span-2 text-right">
                    <span class="text-sm">R {{view?.itineraryOption?.salesTaxAmount | number:'1.2-2'}}</span>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-4 mb-2">
                <div class="col-span-10 text-right">
                    <span class="text-sm font-medium text-gray-700">Property Fees</span><br/>
                    <small class="text-xs text-gray-500">To be paid at the property</small>
                </div>
                <div class="col-span-2 text-right">
                    <span class="text-sm">R {{view?.itineraryOption?.atPropertyAmount | number:'1.2-2'}}</span>
                </div>
            </div>
            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-10 text-right">
                    <span class="font-bold">Total</span>
                </div>
                <div class="col-span-2 text-right">
                    <span class="font-bold">R {{view?.itineraryOption?.totalCurrent | number:'1.2-2'}}</span>
                </div>
            </div>
            
            <hr class="my-6 border-gray-200">

            <div class="grid grid-cols-12 gap-4" *ngIf="!view.isViewOnly">
                <div class="col-span-12">
                    <p class="text-sm text-gray-700">Please review and tick all below conditions to proceed:</p>
                </div>
            
                <!-- Checkbox 1 -->
                <div class="col-span-12">
                    <div class="flex items-center">
                        <input type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" 
                               id="chk1" [(ngModel)]="view.chk1">
                        <label for="chk1" class="ml-2 text-sm font-medium text-gray-700">
                            I understand that I am only reserving the services and that confirmation still needs to be received from the suppliers.
                        </label>
                    </div>
                </div>
                
                <!-- Checkbox 2 -->
                <div class="col-span-12">
                    <div class="flex items-center">
                        <input type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" 
                               id="chk2" [(ngModel)]="view.chk2">
                        <label for="chk2" class="ml-2 text-sm font-medium text-gray-700">
                            Reservations are only held for 24 hours and only confirmed once payment is received.
                        </label>
                    </div>
                </div>
                
                <!-- Checkbox 3 -->
                <div class="col-span-12">
                    <div class="flex items-center">
                        <input type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" 
                               id="chk3" [(ngModel)]="view.chk3">
                        <label for="chk3" class="ml-2 text-sm font-medium text-gray-700">
                            I have read and accepted the <a href="https://andgo.com/terms-and-conditions" class="text-blue-600 hover:underline" target="_blank">WTB terms and conditions</a>.
                        </label>
                    </div>
                </div>
                
                <!-- Checkbox 4 -->
                <div class="col-span-12">
                    <div class="flex items-center">
                        <input type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" 
                               id="chk4" [(ngModel)]="view.chk4">
                        <label for="chk4" class="ml-2 text-sm font-medium text-gray-700">
                            I confirm that all names are as per passport documents.
                        </label>
                    </div>
                </div>
                
                <!-- Checkbox 5 -->
                <div class="col-span-12">
                    <div class="flex items-center">
                        <input type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" 
                               id="chk5" [(ngModel)]="view.chk5">
                        <label for="chk5" class="ml-2 text-sm font-medium text-gray-700">
                            I have read and accepted the <a href="https://developer.expediapartnersolutions.com/terms/en" class="text-blue-600 hover:underline" target="_blank">supplier terms and conditions</a>.
                        </label>
                    </div>
                </div>
                
                <!-- Checkbox 6 -->
                <div class="col-span-12">
                    <div class="flex items-center">
                        <input type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" 
                               id="chk6" [(ngModel)]="view.chk6">
                        <label for="chk6" class="ml-2 text-sm font-medium text-gray-700">
                            I have read and accepted the <a href="http://developer.ean.com/terms/agent/en/" class="text-blue-600 hover:underline" target="_blank">agent terms and conditions</a>.
                        </label>
                    </div>
                </div>
                
                <!-- Checkbox 7 -->
                <div class="col-span-12">
                    <div class="flex items-center">
                        <input type="checkbox" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500" 
                               id="chk7" [(ngModel)]="view.chk7">
                        <label for="chk7" class="ml-2 text-sm font-medium text-gray-700">
                            I acknowledge that this is a packaged rate when combined with other transport services.
                        </label>
                    </div>
                </div>
            </div>

            </div>
        </div>
    </div>
    <div class="flex items-center justify-between p-6 border-t border-gray-200 rounded-b dark:border-gray-600" *ngIf="view.itineraryOption">
        <button type="button" class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10" (click)="close()">Close</button>

    <button 
        type="button" 
        class="text-white font-medium bg-blue-400 rounded-lg text-sm px-5 py-2.5 text-center focus:ring-4 focus:outline-none focus:ring-blue-300"
        *ngIf="!view.isViewOnly"
        
        (click)="itinPersonAdd(view.itineraryOption,false )">
        Reserve now
    </button>
    <!--<button 
         type="button" 
        class="text-white font-medium bg-blue-400 rounded-lg text-sm px-5 py-2.5 text-center focus:ring-4 focus:outline-none focus:ring-blue-300"
        [ngClass]="{
            'bg-blue-700 hover:bg-blue-800': view.chk1 && view.chk2 && view.chk3 && view.chk4 && view.chk5 && view.chk6 && view.chk7,
            'bg-gray-400 cursor-not-allowed': !(view.chk1 && view.chk2 && view.chk3 && view.chk4 && view.chk5 && view.chk6 && view.chk7)
        }"
        [disabled]="!(view.chk1 && view.chk2 && view.chk3 && view.chk4 && view.chk5 && view.chk6 && view.chk7)"

        (click)="itinPersonAdd(view.itineraryOption,false )">
        Reserve now
    </button> -->
    </div>
</section>
       
